/**
 * Packaging Product galleries — front-end interactions.
 *
 * Enqueued as the block's `viewScript`. Powers each product's image carousel
 * (one slide per page, arrows page through the rest) and a shared lightbox.
 * Vanilla JS, no dependencies.
 */

( function () {
	if ( window.__delinePackagingDetailInit ) {
		return;
	}
	window.__delinePackagingDetailInit = true;

	var SLIDES_PER_PAGE = 1;

	function pageCount( gallery ) {
		var slides = gallery.querySelectorAll( '.deline-packaging-detail__slide' );
		return Math.max( 1, Math.ceil( slides.length / SLIDES_PER_PAGE ) );
	}

	function showPage( gallery, nextPage ) {
		var slides = gallery.querySelectorAll( '.deline-packaging-detail__slide' );
		if ( ! slides.length ) {
			return 0;
		}

		var total = pageCount( gallery );
		var page = ( ( nextPage % total ) + total ) % total;
		var start = page * SLIDES_PER_PAGE;

		slides.forEach( function ( slide, i ) {
			slide.classList.toggle( 'is-visible', i >= start && i < start + SLIDES_PER_PAGE );
		} );

		gallery.querySelector( '.deline-packaging-detail__gallery-track' ).setAttribute( 'data-active-page', String( page ) );
		return page;
	}

	function getActivePage( gallery ) {
		var track = gallery.querySelector( '.deline-packaging-detail__gallery-track' );
		if ( ! track ) {
			return 0;
		}
		var raw = parseInt( track.getAttribute( 'data-active-page' ) || '0', 10 );
		return Number.isNaN( raw ) ? 0 : raw;
	}

	function ensureLightbox() {
		var existing = document.querySelector( '.deline-packaging-detail__lightbox' );
		if ( existing ) {
			return existing;
		}

		var lightbox = document.createElement( 'div' );
		lightbox.className = 'deline-packaging-detail__lightbox';
		lightbox.setAttribute( 'aria-hidden', 'true' );
		lightbox.innerHTML =
			'<button type="button" class="deline-packaging-detail__lightbox-close" aria-label="Close">×</button>' +
			'<button type="button" class="deline-packaging-detail__lightbox-arrow deline-packaging-detail__lightbox-arrow--prev" aria-label="Previous image">‹</button>' +
			'<img class="deline-packaging-detail__lightbox-image" src="" alt="" />' +
			'<button type="button" class="deline-packaging-detail__lightbox-arrow deline-packaging-detail__lightbox-arrow--next" aria-label="Next image">›</button>';
		document.body.appendChild( lightbox );

		return lightbox;
	}

	function getGroupSlides( groupName ) {
		var selectors = '.deline-packaging-detail__gallery[data-gallery-group="' + groupName + '"] .deline-packaging-detail__lightbox-trigger';
		return Array.prototype.slice.call( document.querySelectorAll( selectors ) );
	}

	function bindGallery( gallery ) {
		var prev = gallery.querySelector( '.deline-packaging-detail__arrow--prev' );
		var next = gallery.querySelector( '.deline-packaging-detail__arrow--next' );

		showPage( gallery, 0 );

		if ( prev ) {
			prev.addEventListener( 'click', function () {
				showPage( gallery, getActivePage( gallery ) - 1 );
			} );
		}

		if ( next ) {
			next.addEventListener( 'click', function () {
				showPage( gallery, getActivePage( gallery ) + 1 );
			} );
		}

		var groupName = gallery.getAttribute( 'data-gallery-group' ) || '';
		var triggers = gallery.querySelectorAll( '.deline-packaging-detail__lightbox-trigger' );
		if ( ! triggers.length ) {
			return;
		}

		var lightbox = ensureLightbox();
		var lightboxImage = lightbox.querySelector( '.deline-packaging-detail__lightbox-image' );
		var closeBtn = lightbox.querySelector( '.deline-packaging-detail__lightbox-close' );
		var lbPrev = lightbox.querySelector( '.deline-packaging-detail__lightbox-arrow--prev' );
		var lbNext = lightbox.querySelector( '.deline-packaging-detail__lightbox-arrow--next' );
		var currentIndex = 0;
		var currentGroup = groupName;

		function renderLightboxImage() {
			var slides = getGroupSlides( currentGroup );
			if ( ! slides.length ) {
				return;
			}
			currentIndex = ( ( currentIndex % slides.length ) + slides.length ) % slides.length;
			var trigger = slides[ currentIndex ];
			lightboxImage.src = trigger.getAttribute( 'data-full-src' ) || '';
			lightboxImage.alt = trigger.getAttribute( 'data-alt' ) || '';
		}

		function openLightbox( index ) {
			currentGroup = groupName;
			currentIndex = index;
			renderLightboxImage();
			lightbox.classList.add( 'is-open' );
			lightbox.setAttribute( 'aria-hidden', 'false' );
			document.body.style.overflow = 'hidden';
		}

		function closeLightbox() {
			lightbox.classList.remove( 'is-open' );
			lightbox.setAttribute( 'aria-hidden', 'true' );
			document.body.style.overflow = '';
		}

		triggers.forEach( function ( trigger, triggerIndex ) {
			trigger.addEventListener( 'click', function () {
				openLightbox( triggerIndex );
			} );
		} );

		closeBtn.addEventListener( 'click', closeLightbox );
		lightbox.addEventListener( 'click', function ( event ) {
			if ( event.target === lightbox ) {
				closeLightbox();
			}
		} );

		lbPrev.addEventListener( 'click', function () {
			currentIndex -= 1;
			renderLightboxImage();
		} );

		lbNext.addEventListener( 'click', function () {
			currentIndex += 1;
			renderLightboxImage();
		} );

		document.addEventListener( 'keydown', function ( event ) {
			if ( ! lightbox.classList.contains( 'is-open' ) ) {
				return;
			}

			if ( event.key === 'Escape' ) {
				closeLightbox();
			}

			if ( event.key === 'ArrowLeft' ) {
				currentIndex -= 1;
				renderLightboxImage();
			}

			if ( event.key === 'ArrowRight' ) {
				currentIndex += 1;
				renderLightboxImage();
			}
		} );
	}

	function init() {
		Array.prototype.slice
			.call( document.querySelectorAll( '.deline-packaging-detail__gallery' ) )
			.forEach( bindGallery );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
} )();
